import api from './config';

// 获取主题列表
export const getThemes = async (params = {}) => {
  return api.get('/themes', { params });
};

// 获取单个主题详情
export const getTheme = async (themeId) => {
  return api.get(`/themes/${themeId}`);
};

// 创建主题
export const createTheme = async (data) => {
  return api.post('/themes', data);
};

// 更新主题
export const updateTheme = async (themeId, data) => {
  return api.put(`/themes/${themeId}`, data);
};

// 删除主题
export const deleteTheme = async (themeId) => {
  return api.delete(`/themes/${themeId}`);
};

// 切换上下架状态
export const togglePublishTheme = async (themeId) => {
  return api.put(`/themes/${themeId}/toggle-publish`);
};

// 上传主题图片
export const uploadThemeImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  // 不要手动设置 Content-Type，让浏览器自动设置（包含 boundary）
  return api.post('/themes/upload-image', formData);
};

